/* ============================================================
   PROJEKTSEITEN — Format-Raster + Lightbox + Scroll-Reveal
   Version 1.1 — 16.10.2026 (Format-Raster, Variante A)
   Ziel: assets/projektseiten.js im Shopify-Theme

   Wird von sections/main-projektseite.liquid mit defer geladen.
   Laeuft nur, wenn .success-story-wrapper vorhanden ist.
   ============================================================ */
(function () {
  'use strict';

  var wrapper = document.querySelector('.success-story-wrapper');
  if (!wrapper) return;

  /* ---------- Scroll-Reveal ----------
     Der Startzustand (opacity 0) kommt aus dem CSS und greift nur
     unter [data-reveal]. Faellt JS aus, bleibt das Attribut stehen
     und die Kacheln waeren unsichtbar. Deshalb wird das Attribut
     hier zuerst entfernt, sobald feststeht, dass nicht animiert
     wird, und die Animation sonst sofort verdrahtet. */
  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (wrapper.hasAttribute('data-reveal')) {
    if (!('IntersectionObserver' in window) || reduceMotion) {
      wrapper.removeAttribute('data-reveal');
    } else {
      var revealObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

      Array.prototype.forEach.call(
        wrapper.querySelectorAll('.si-reveal'),
        function (el) { revealObserver.observe(el); }
      );
    }
  }

  /* ---------- Format-Raster (Variante A, 16.10.2026) ----------
     Galerie und Vorher-Bilder werden nach Bildformat in Reihen
     gesetzt: 3 x Hochformat, 2 x Querformat oder Quer + Hoch;
     ein als "large" markiertes Querformat-Bild steht allein in
     16:9. Das Format kommt aus einer 40 px breiten Vorschau vom
     Shopify-CDN, die Seiten-HTML bleibt unverändert. Klappt das
     nicht innerhalb von 4 s, bleibt das alte Raster stehen. */
  function thumbUrl(src) {
    if (!src) return null;
    return /[?&]width=\d+/.test(src)
      ? src.replace(/([?&])width=\d+/, '$1width=40')
      : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=40';
  }

  function measure(fig) {
    return new Promise(function (resolve) {
      var img = fig.querySelector('img');
      var url = img ? thumbUrl(img.getAttribute('src')) : null;
      if (!url) { resolve(null); return; }
      var probe = new Image();
      probe.onload = function () {
        resolve(probe.naturalWidth && probe.naturalHeight
          ? probe.naturalWidth / probe.naturalHeight : null);
      };
      probe.onerror = function () { resolve(null); };
      probe.src = url;
    });
  }

  var SIZES = {
    full: '(max-width: 749px) 100vw, 1400px',
    q4: '(max-width: 749px) 100vw, 900px',
    q3: '(max-width: 749px) 100vw, 680px',
    h: '(max-width: 749px) 100vw, 450px'
  };

  function pack(items) {
    var rest = items.slice();
    var rows = [];
    function fullQ(x) { return x.large && x.q; }
    while (rest.length) {
      var a = rest.shift();
      if (fullQ(a)) { rows.push([[a, 'full']]); continue; }
      var i, b, c;
      if (a.q) {
        for (i = 0; i < rest.length && fullQ(rest[i]); i++) {}
        if (i < rest.length && i < 3) {
          b = rest.splice(i, 1)[0];
          if (b.q && rest.length === 1 && !rest[0].q) {
            /* Q Q H am Ende: Q + H gleich hoch, das zweite Q in 16:9 */
            rows.push([[a, 'q4'], [rest.shift(), 'h2']]);
            rows.push([[b, 'full']]);
            continue;
          }
          rows.push(b.q ? [[a, 'q3'], [b, 'q3']] : [[a, 'q4'], [b, 'h2']]);
        } else {
          rows.push([[a, 'full']]);
        }
        continue;
      }
      /* Keine einzelne Kachel am Ende: 4 Hochformate = 2 + 2 */
      var run = 1;
      while (run - 1 < rest.length && !rest[run - 1].q) run++;
      if (run >= 4 && run % 3 === 1) {
        rows.push([[a, 'pairL'], [rest.shift(), 'pairR']]);
        continue;
      }
      var hs = [];
      for (i = 0; i < rest.length && hs.length < 2; i++) {
        if (fullQ(rest[i])) break;
        if (!rest[i].q) hs.push(i);
      }
      if (hs.length === 2 && hs[1] < 4) {
        b = rest[hs[0]]; c = rest[hs[1]];
        rest.splice(hs[1], 1); rest.splice(hs[0], 1);
        rows.push([[a, 'h3'], [b, 'h3'], [c, 'h3']]);
        continue;
      }
      var qi = -1;
      for (i = 0; i < rest.length && i < 3; i++) {
        if (rest[i].q && !fullQ(rest[i])) { qi = i; break; }
      }
      if (qi > -1) {
        b = rest.splice(qi, 1)[0];
        rows.push([[b, 'q4'], [a, 'h2']]);
        continue;
      }
      if (hs.length) {
        b = rest.splice(hs[0], 1)[0];
        rows.push([[a, 'pairL'], [b, 'pairR']]);
        continue;
      }
      rows.push([[a, 'solo']]);
    }
    return rows;
  }

  var LAYOUT = {
    full:  { col: '1 / -1',     cls: 'si-quer si-full', sizes: 'full' },
    q3:    { col: 'span 3',     cls: 'si-quer',         sizes: 'q3' },
    q4:    { col: 'span 4',     cls: 'si-quer',         sizes: 'q4' },
    h2:    { col: 'span 2',     cls: 'si-hoch',         sizes: 'h' },
    h3:    { col: 'span 2',     cls: 'si-hoch',         sizes: 'h' },
    pairL: { col: '2 / span 2', cls: 'si-hoch',         sizes: 'h' },
    pairR: { col: '4 / span 2', cls: 'si-hoch',         sizes: 'h' },
    solo:  { col: '3 / span 2', cls: 'si-hoch',         sizes: 'h' }
  };

  function applyRows(grid, figs, ratios) {
    if (ratios.some(function (r) { return !r; })) return;
    var items = figs.map(function (fig, k) {
      return { fig: fig, q: ratios[k] > 1.05, large: fig.classList.contains('large') };
    });
    var frag = document.createDocumentFragment();
    pack(items).forEach(function (row) {
      var rowEl = document.createElement('div');
      rowEl.className = 'si-row';
      if (row.some(function (e) { return e[1] === 'q4'; })) rowEl.className += ' si-row--mix';
      row.forEach(function (entry) {
        var fig = entry[0].fig, l = LAYOUT[entry[1]];
        fig.classList.add('si-tile');
        l.cls.split(' ').forEach(function (c) { fig.classList.add(c); });
        fig.style.gridColumn = l.col;
        var img = fig.querySelector('img');
        if (img && img.hasAttribute('srcset')) img.setAttribute('sizes', SIZES[l.sizes]);
        rowEl.appendChild(fig);
      });
      frag.appendChild(rowEl);
    });
    grid.appendChild(frag);
    grid.classList.add('is-packed');
  }

  Array.prototype.forEach.call(
    wrapper.querySelectorAll('.gallery-grid, .comparison-grid'),
    function (grid) {
      var figs = Array.prototype.filter.call(grid.children, function (el) {
        return el.tagName === 'FIGURE';
      });
      if (figs.length < 2) return;
      var timedOut = false;
      var timer = setTimeout(function () { timedOut = true; }, 4000);
      Promise.all(figs.map(measure)).then(function (ratios) {
        clearTimeout(timer);
        if (!timedOut) applyRows(grid, figs, ratios);
      });
    }
  );

  /* ---------- Lightbox ---------- */
  var lightbox = wrapper.querySelector('#si-lightbox');
  if (!lightbox) return;

  var imgEl = lightbox.querySelector('.si-lightbox__image');
  var captionEl = lightbox.querySelector('.si-lightbox__caption');
  var counterEl = lightbox.querySelector('.si-lightbox__counter');
  var closeBtn = lightbox.querySelector('.si-lightbox__close');
  var prevBtn = lightbox.querySelector('.si-lightbox__prev');
  var nextBtn = lightbox.querySelector('.si-lightbox__next');

  /* Die Liste wird bei jedem Öffnen neu gelesen, weil das
     Format-Raster die Bilder nachträglich in Reihen umsortiert. */
  var IMG_SEL = '.comparison-item img, .gallery-item img';
  var images = Array.prototype.slice.call(wrapper.querySelectorAll(IMG_SEL));
  if (!images.length) return;

  var currentIndex = 0;
  var lastFocused = null;

  function show(idx) {
    currentIndex = ((idx % images.length) + images.length) % images.length;
    var img = images[currentIndex];
    imgEl.src = img.currentSrc || img.src;
    imgEl.alt = img.alt || '';
    var figure = img.closest ? img.closest('figure') : null;
    var caption = figure ? figure.querySelector('figcaption') : null;
    captionEl.textContent = caption ? caption.textContent.trim() : (img.alt || '');
    counterEl.textContent = (currentIndex + 1) + ' / ' + images.length;
  }

  function openAt(idx) {
    images = Array.prototype.slice.call(wrapper.querySelectorAll(IMG_SEL));
    lastFocused = document.activeElement;
    show(idx);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function close() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  images.forEach(function (img) {
    img.addEventListener('click', function (e) {
      e.preventDefault();
      var list = Array.prototype.slice.call(wrapper.querySelectorAll(IMG_SEL));
      openAt(list.indexOf(img));
    });
  });

  closeBtn.addEventListener('click', close);
  nextBtn.addEventListener('click', function () { show(currentIndex + 1); });
  prevBtn.addEventListener('click', function () { show(currentIndex - 1); });

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;

    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowRight') { show(currentIndex + 1); return; }
    if (e.key === 'ArrowLeft') { show(currentIndex - 1); return; }

    /* Fokus im Dialog halten, solange er offen ist */
    if (e.key === 'Tab') {
      var focusables = [closeBtn, prevBtn, nextBtn];
      var i = focusables.indexOf(document.activeElement);
      e.preventDefault();
      var next = e.shiftKey ? i - 1 : i + 1;
      focusables[(next + focusables.length) % focusables.length].focus();
    }
  });

  var touchStartX = 0;
  lightbox.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  lightbox.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].screenX - touchStartX;
    if (Math.abs(dx) > 50) show(currentIndex + (dx < 0 ? 1 : -1));
  }, { passive: true });
})();